import React from "react";
import classNames from "classnames";
import { NavLink, useLocation } from "react-router-dom";
import { getCurrentCulture } from "@utils";

type AdministrationSideMenuItem = {
	path: string;
	translation: string;
	styling: string;
};

export default function AdministrationSideMenuItem(
	props: AdministrationSideMenuItem
) {
	const { path, translation, styling } = props;

	const pathLocation = useLocation();

	return (
		<li className="nav--secondary__item nav--account__item">
			<NavLink
				to={path}
				className="nav--secondary__link"
				activeClassName="is-selected"
				isActive={(_, location) => location.pathname.includes(path)}
				title={translation}
			>
				<i
					className={classNames(
						`nav--secondary__icon u-icon u-icon--big u-icon--${styling}--alt`,
						{
							[`u-icon--${styling}--bold u-color--core--snow`]:
								pathLocation.pathname.includes(path),
						}
					)}
				/>

				{pathLocation.pathname.includes("gaming-history") ||
				pathLocation.pathname.includes("account-settings") ? (
					<div
						className={classNames("nav--secondary__title", {
							"is-long":
								translation?.length > 11 &&
								(getCurrentCulture() == "sv" ||
									getCurrentCulture() == "da"),
						})}
					>
						{translation}
					</div>
				) : (
					<div className="nav--secondary__title">{translation}</div>
				)}
			</NavLink>
		</li>
	);
}
